import { colors } from './colors';
import { ThemeType } from './themeTypes';

export const defaultTheme: ThemeType = {
  name: 'defaultTheme',
  colors,
  colorControls: colors.cyan,
  colorControlsFont: colors.white,
  fontActiveItemSideBar: colors.cyan,
  backgroundControls: colors.gray,
  errorColor: colors.red,
  backgroundSideBar: 'linear-gradient(#66615B 0%, #000 80%)',
  fontColorSideBar: colors.white,
  backgroundApp: '#f4f3ef',
  cardRounded: '',
  topBarColor: '',
  fontSizeApp: '',
  extendedNavigationBar: false,
  fontColorRightPanel: colors.black,
  fontWeightRightPanel: '300',
  fontColorFooter: colors.black,
  fontWeightFooter: '300',
};

export const MarketSpaceTheme: ThemeType = {
  name: 'MarketSpaceTheme',
  colors,

  /* ---- Navigation menu ----- */
  backgroundSideBar: '#002d56',
  fontColorSideBar: colors.white,
  fontActiveItemSideBar: '#002d56',
  fontWeightSideBar: '800',

  /* ---- App ----- */
  backgroundApp: '#d9d9d9',
  backgroundControls: colors.gray,
  colorControls: '#3F92D4',
  colorControlsFont: colors.white,
  errorColor: colors.red,
  typeAppCorner: 'boxy',
  /* ---- other ----- */
  cardRounded: '',
  topBarColor: '',
  fontSizeApp: '',
  extendedNavigationBar: false,
  fontColorRightPanel: colors.black,
  fontWeightRightPanel: '300',
  fontColorFooter: colors.black,
  fontWeightFooter: '300',
};
